<template>
  <div
    v-if="value"
    class="p-advertorial-insert"
    data-test-advertorial-insert
    @click.capture="onClick"
    v-observe-visibility="{
      callback: onVisibilityChanged,
      throttle: 1000,
      intersection: { threshold: 0.75 },
      once: true,
    }"
  >
    <adn-image
      v-if="!value.catchphrase && !value.redirectUrl"
      :source="value.backgroundImageUrl"
      class="p-advertorial-insert__image"
    ></adn-image>

    <idf-component-link v-if="!value.catchphrase && value.redirectUrl" :url="value.redirectUrl">
      <adn-image
        :source="value.backgroundImageUrl"
        class="p-advertorial-insert__image p-advertorial-insert__image--click"
      ></adn-image>
    </idf-component-link>

    <idf-promotion-card
      v-if="value.catchphrase"
      :cta-icon-name="value.buttonIconName"
      :cta-label="value.buttonName"
      :cta-link="value.redirectUrl"
      :image-url="value.backgroundImageUrl"
      :title="value.catchphrase"
      class="p-advertorial-insert__card"
      type="medium"
    ></idf-promotion-card>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'
import ObserveVisibility from 'vue3-observe-visibility/src/directives/observe-visibility'
import { useAnalyticService } from '@b2ag/plugin-aladin-gtm'
import AdnImage from '@b2ag/design-system/src/components/AdnImage/AdnImage.vue'
import IdfComponentLink from '@b2ag/design-system/src/components/IdfComponentLink/IdfComponentLink.vue'
import IdfPromotionCard from '@b2ag/design-system/src/components/IdfPromotionCard/IdfPromotionCard.vue'
import type { AdvertorialInsert } from '../../../domain/Advertorialnsert'

const vObserveVisibility = ObserveVisibility

defineOptions({
  name: 'PAdvertorialInsert',
})

const props = defineProps({
  value: {
    type: Object as PropType<AdvertorialInsert>,
    required: true,
  },
})

const emit = defineEmits(['card-visible'])

const onClick = () => {
  useAnalyticService().trackEvent('click_advertorial_insert', {
    content_title: props.value.id,
  })
}

const onVisibilityChanged = (isVisible) => {
  if (isVisible) emit('card-visible')
}
</script>

<style lang="scss">
.p-advertorial-insert {
  --idf-promotion-card-background-color: #5bb3f0;
  --idf-promotion-card-content-text-color: #fff;
  --idf-promotion-card-cta-background-color: #085691;

  width: 100%;

  &__image {
    border: 1px solid var(--color-grey-light);
    border-radius: var(--border-radius-2);
    width: 100%;

    &.p-advertorial-insert__image--click {
      &:hover {
        border-color: var(--color-blue);
        box-shadow: var(--shadow-dark);
      }
    }
  }
}
</style>
